export class InputDocument {

    documentId: string
    type: string
    additionalInformation: InputDocumentAdditionalInformation[]

    constructor(documentId: string, type: string, additionalInformation: InputDocumentAdditionalInformation[]) {
        this.documentId = documentId;
        this.type = type;
        this.additionalInformation = additionalInformation;
    }
}

export class InputDocumentAdditionalInformation {

    title: string
    key: string
    value: string

    constructor(title: string, key: string, value: string) {
        this.title = title;
        this.key = key;
        this.value = value;
    }
}